<template>
  <div class="reportCenter">
    <el-menu
      class="reportCenter__menu"
      :text-color="'#B3B3B3'"
      background-color="#333333"
      :default-active="$route.name"
      @select="selectTag"
    >
      <!-- <el-menu-item index="deviceInstall">
        <i class="reportCenter__icon iconfont icon-anzhuang"></i>
        <span slot="title">设备安装汇总</span>
      </el-menu-item> -->

      <!-- <el-submenu index="0">
        <template slot="title">
          <i class="reportCenter__icon iconfont icon-anzhuang"></i>
          <span
            slot="title"
            style="padding-right:80px"
          >设备安装汇总</span>
        </template>

      </el-submenu> -->

      <el-menu-item index="offLine">
        <!-- <i class="reportCenter__icon iconfont icon-yuan"></i> -->
        <span slot="title">离线报表</span>
      </el-menu-item>
      <!-- <el-menu-item index="realTimeAlarm">
        <span slot="title">实时报警</span>
      </el-menu-item> -->

      <el-menu-item index="commandReport">
        <!-- <i class="reportCenter__icon iconfont icon-yuan"></i> -->
        <span slot="title">指令报表</span>
      </el-menu-item>
      <!-- <el-menu-item index="batteryHistory">
        <span slot="title">电池记录</span>
      </el-menu-item> -->
      <el-menu-item index="dataReport">
        <span slot="title">数据记录</span>
      </el-menu-item>
      <el-menu-item index="permissionsLog">
        <span slot="title">授权记录</span>
      </el-menu-item>
      <el-menu-item index="remoteUpgradeFile">
        <span slot="title">远程升级文件</span>
      </el-menu-item>
      <el-menu-item index="remoteUpgradeLog">
        <span slot="title">远程升级日志</span>
      </el-menu-item>
      <el-menu-item v-if="USER.accountType === 1" index="driverManage">
        <span slot="title">注册信息</span>
      </el-menu-item>
      <el-menu-item index="alarmLog">
        <span slot="title">历史报警报表</span>
      </el-menu-item>
      <el-menu-item index="fence">
        <span slot="title">重点区域</span>
      </el-menu-item>
    </el-menu>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";

export default {
  data() {
    return {};
  },
  // beforeRouteUpdate(to, from, next) {
  //   next();
  // },
  computed: {
    ...mapState(["USER"]),
  },
  methods: {
    ...mapMutations(["COMMIT_ROUTERNAME"]),

    async selectTag(key) {
      this.$route.name !== key && this.$router.push({ name: key });
      await this.COMMIT_ROUTERNAME(key);
    }
  }
};
</script>
<style lang="scss" scoped>
.el-menu {
  border-right: none;
}
.point {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #fff;
}
.reportCenter {
  height: 100%;
  background: #414141;
  display: flex;
  flex-direction: row;
  &__menu {
    width: 220px;
    @include scrollBar();
    overflow-y: auto;
    // margin-top: 50px;
    // padding: 15px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    box-shadow: 2px 0px 4px 0px rgba(0, 0, 0, 0.05);
  }

  &__icon {
    margin-right: 10px;
    font-size: 6px;
  }
}
</style>
